/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { createContext } from 'react';
import { noop } from 'lodash';

const initialContext = Object.freeze({
  /**
   * If the store dropdown should be opened from a different component
   *
   * @type {boolean}
   */
  openStoreDropdown: false,
  /**
   * Sets the value of the store dropdown
   *
   * @type {function}
   */
  setOpenStoreDropdown: noop
});

const SiteContext = createContext(initialContext);

SiteContext.defaultValue = initialContext;

export default SiteContext;
